import React, {
  FC, HTMLProps, ReactElement, ReactNode, useMemo,
} from 'react';
import classNames from 'classnames';
import OverlayTrigger, { Position, TriggerType } from 'components/UI_kit_3/Popover/OverlayTrigger/OverlayTrigger';
import styles from './Tooltip.module.scss';

interface ITooltipProps extends HTMLProps<HTMLDivElement> {
  text: string | ReactNode
  description?: string
  active?: boolean
  trigger?: TriggerType;
  children: ReactElement;
  animationDuration?: number
  position?: Position
  arrow?: boolean
}

const Tooltip: FC<ITooltipProps> = ({
  text,
  description,
  active = true,
  trigger = 'hover',
  children,
  animationDuration,
  position = 'top',
  className,
  arrow, ...props
}) => {
  const positionClass = useMemo(() => styles[`position-${position}`], [position, styles]);
  return (
    <OverlayTrigger
      trigger={trigger}
      animationDuration={animationDuration}
      position={position}
      offset={4}
      active={active}
      overlay={(
        <div
          className={classNames(styles.tooltip, className, {
            [positionClass]: arrow,
            [styles.arrow]: arrow,
          })}
          {...props}
        >
          <div>{text}</div>
          {description && <div className={styles.description}>{description}</div>}
        </div>
      )}
    >
      {children}
    </OverlayTrigger>
  );
};

export default Tooltip;
